import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { FormattedMessage } from 'react-intl';

import { mapCareer } from '../../reducers/careerReducer';
import { fetchCareerIfNeeded, fetchCareer } from '../../actions/career';
import EditPanel from './EditPanel';

const Career = ({
  loaded,
  dispatch,
  careerData,
  showErrorMessage,
  errorMessage,
  EmployeeMasterID,
}) =>
  (<EditPanel
    title={<FormattedMessage id="career.title" />}
    emptyText="career.empty"
    loaded={loaded}
    showErrorMessage={showErrorMessage}
    errorMessage={errorMessage}
    onOpen={() => dispatch(fetchCareerIfNeeded())}
    modelName="EmployeeMasterCareer"
    dataSource={careerData}
    mapModel={mapCareer}
    EmployeeMasterID={EmployeeMasterID}
    fetchData={fetchCareer}
  />);

function mapStateToProps(state) {
  return {
    loaded: state.careerReducer.loaded,
    form: state.form.EmployeeMasterCareer,
    careerData: state.careerReducer.careerData,
    EmployeeMasterID: state.loginReducer.user.EmployeeMasterID,
    showErrorMessage: (state.careerReducer.error && state.careerReducer.error.Message.length) > 0,
    errorMessage: (state.educationReducer.error && state.educationReducer.error.Message) || '',
  };
}

Career.propTypes = {
  loaded: PropTypes.bool,
  dispatch: PropTypes.func.isRequired,
  careerData: PropTypes.array,
  showErrorMessage: PropTypes.bool,
  errorMessage: PropTypes.string,
  EmployeeMasterID: PropTypes.number,
};

export default connect(mapStateToProps)(Career);



// WEBPACK FOOTER //
// ./src/components/profile/Career.js